import { Invoice } from "./invoice";
import { Claim } from "./claim";
import { Coverage, PreexistingConditionsCoverage, WorldwideProtectionCoverage } from "./coverage";

export class PetInsuranceData {
  pet_name: string;
  pet_species: string;
  pet_gender: string;
  phone_number?: string;
  city?: string;
  country?: string;
  street?: string;
  house_number?: string;
  zip?: string;
  parent_birthdate?: string;
  lang?: string;
  german_salutation?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  breed_type: boolean;
  breed: string;
  birthdate: string;
  neutered: boolean;
  housecat?: boolean;
  full_contract_number: string;
  contract_number: string;
  base_number: string;
  customer_id?: string;
  status: string;
  start_date: string;
  end_date: string;
  cancellation_date: string;
  date_of_wish_to_cancel: string;
  yearly_gross_premium: number;
  yearly_gross_premium_pro_rata: number;
  yearly_net_premium: number;
  payment_interval: PaymentFrequency;
  taxes: number;
  product_bundle: string;
  yearly_net_premium_base: number;
  annual_franchise: number;
  deductible_percentage_until_9_years: number;
  deductible_percentage_after_9_years: number;
  overall_sum_insured: number;
  accident_and_illness_coverage: Coverage;
  illness_advanced_treatment_coverage: Coverage;
  illness_complementary_treatment_coverage: Coverage;
  illness_behavioural_treatment_coverage: Coverage;
  accident_dental_treatment_coverage: Coverage;
  illness_dental_treatment_coverage: Coverage;
  emergency_minding_coverage: Coverage;
  emergency_treatment_coverage: Coverage;
  medical_food_coverage: Coverage;
  preventive_care_coverage: Coverage;
  preexisting_conditions_coverage: PreexistingConditionsCoverage;
  worldwide_protection_coverage: WorldwideProtectionCoverage;
  claims: Claim[] | null;
  invoices: Invoice[] | null;
  paidAmount: number = 0;
  usedFranchise: number = 0;
  contractStatus:  'expired' | 'active' | 'future' = 'expired';

  constructor(
    pet_name: string, pet_species: string, pet_gender: string, breed_type: boolean, breed: string, birthdate: string,
    neutered: boolean, full_contract_number: string, contract_number: string, base_number: string, status: string, start_date: string,
    phoneNumber: string, city: string, country: string, street: string, houseNumber: string, zip: string,
    end_date: string, cancellation_date: string, date_of_wish_to_cancel: string, yearly_gross_premium: number,
    yearly_gross_premium_pro_rata: number, yearly_net_premium: number, payment_interval: PaymentFrequency, taxes: number,
    product_bundle: string, yearly_net_premium_base: number, annual_franchise: number,
    deductible_percentage_until_9_years: number, deductible_percentage_after_9_years: number,
    overall_sum_insured: number, accident_and_illness_coverage: Coverage, illness_advanced_treatment_coverage: Coverage,
    illness_complementary_treatment_coverage: Coverage, illness_behavioural_treatment_coverage: Coverage,
    accident_dental_treatment_coverage: Coverage, illness_dental_treatment_coverage: Coverage,
    emergency_minding_coverage: Coverage, emergency_treatment_coverage: Coverage, medical_food_coverage: Coverage,
    preventive_care_coverage: Coverage, preexisting_conditions_coverage: PreexistingConditionsCoverage,
    worldwide_protection_coverage: WorldwideProtectionCoverage, claims: Claim[] | null, invoices: Invoice[] | null
  ) {
    this.pet_name = pet_name;
    this.pet_species = pet_species;
    this.pet_gender = pet_gender;
    this.breed_type = breed_type;
    this.breed = breed;
    this.birthdate = birthdate;
    this.neutered = neutered;
    this.full_contract_number = full_contract_number;
    this.contract_number = contract_number;
    this.base_number = base_number;
    this.status = status;
    this.start_date = start_date;
    this.end_date = end_date;
    this.cancellation_date = cancellation_date;
    this.date_of_wish_to_cancel = date_of_wish_to_cancel;
    this.yearly_gross_premium = yearly_gross_premium;
    this.yearly_gross_premium_pro_rata = yearly_gross_premium_pro_rata;
    this.yearly_net_premium = yearly_net_premium;
    this.payment_interval = payment_interval;
    this.taxes = taxes;
    this.product_bundle = product_bundle;
    this.yearly_net_premium_base = yearly_net_premium_base;
    this.annual_franchise = annual_franchise;
    this.deductible_percentage_until_9_years = deductible_percentage_until_9_years;
    this.deductible_percentage_after_9_years = deductible_percentage_after_9_years;
    this.overall_sum_insured = overall_sum_insured;
    this.accident_and_illness_coverage = accident_and_illness_coverage;
    this.illness_advanced_treatment_coverage = illness_advanced_treatment_coverage;
    this.illness_complementary_treatment_coverage = illness_complementary_treatment_coverage;
    this.illness_behavioural_treatment_coverage = illness_behavioural_treatment_coverage;
    this.accident_dental_treatment_coverage = accident_dental_treatment_coverage;
    this.illness_dental_treatment_coverage = illness_dental_treatment_coverage;
    this.emergency_minding_coverage = emergency_minding_coverage;
    this.emergency_treatment_coverage = emergency_treatment_coverage;
    this.medical_food_coverage = medical_food_coverage;
    this.preventive_care_coverage = preventive_care_coverage;
    this.preexisting_conditions_coverage = preexisting_conditions_coverage;
    this.worldwide_protection_coverage = worldwide_protection_coverage;
    this.claims = claims;
    this.invoices = invoices;
    this.phone_number = phoneNumber;
    this.city = city;
    this.country = country;
    this.street = street;
    this.house_number = houseNumber;
    this.zip = zip;
  }
}

export enum PaymentFrequency {
  YEARLY = 'jährlich',
  BIYEARLY = 'halbjährlich',
  QUARTERLY = 'quartalsweise',
  MONTHLY = 'monatlich'
}
